import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import * as React from 'react';
import styled from 'styled-components';

import { PortalCSS } from '@/atoms/Menu/RadixMenu/common';

export const Popover = React.forwardRef<
  HTMLDivElement,
  DropdownMenuPrimitive.DropdownMenuContentProps
>(({ children, align = 'end', side = 'bottom', ...props }, forwardedRef) => {
  return (
    <DropdownMenuPrimitive.Portal>
      <StyledPortalContent
        align={align}
        side={side}
        {...props}
        ref={forwardedRef}
      >
        {children}
      </StyledPortalContent>
    </DropdownMenuPrimitive.Portal>
  );
});

const StyledPortalContent = styled(DropdownMenuPrimitive.Content)`
  ${PortalCSS}
`;
